/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 -t --transform BlogNews.glb 
Files: BlogNews.glb [13.09KB] > C:\Users\fedde\Downloads\v2\BlogNews-transformed.glb [12.5KB] (5%)
*/

import { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { Icon, IconProps } from "../../components/Icon";
import { Mesh, Vector3, MeshStandardMaterial } from "three";
import { CalloutProps } from "../../components/Callout";

type GLTFResult = GLTF & {
  nodes: {
    WebExp_BlogNews: Mesh;
  };
  materials: { [name: string]: MeshStandardMaterial };
};

export function BlogNews() {
  const calloutProps: CalloutProps = {
    graphicTexturePath: "/images/IconGraphic.png",
    graphicGlb: "/models/Callout/CalloutPlanev02.glb",
    graphicLocation: new Vector3(-0.59, -0.1, 1.1),
    textTitle: "Blog News",
    textTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textTitleColor: "#ffffff",
    textTitleFontSize: 0.4,
    textTitlePosition: new Vector3(-0.6, 0, 1),
    textSubTitle: "Latest News",
    textSubTitleFontSize: 0.2,
    textSubTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textSubTitleColor: "#00EAFF",
    textSubTitlePosition: new Vector3(-0.61, -0.4, 1.21),
    scaleSpeed: 5,
    pivotPoint: new Vector3(-17.1707, -13.329, 26.2265),
    active: false,
  };
  const iconProps: IconProps = {
    name: "Blog News",
    blenderPosition: new Vector3(-17.1707, -26.2265, -13.329),
    idleRotationSpeed: 0.5,
    hoverTranslateY: 5,
    hoverLookAtFactor: 5,
    selectorDimensions: [8, 12, 8],
    paddingLeaveDimensions: [15, 15, 15],
    hoverRotationY: 4,
    cameraPositionSelected: new Vector3(-17.1707, -13.329, 46.2265),
    cameraTargetSelected: new Vector3(-17.1707, -13.329, 26.2265),
    calloutProps: calloutProps,
  };

  //REFS
  const blogNewsRef = useRef(null);
  const { nodes } = useGLTF("/models/BlogNews-transformed.glb") as GLTFResult;
  return (
    <Icon
      name={iconProps.name}
      blenderPosition={iconProps.blenderPosition}
      idleRotationSpeed={iconProps.idleRotationSpeed}
      hoverTranslateY={iconProps.hoverTranslateY}
      hoverLookAtFactor={iconProps.hoverLookAtFactor}
      selectorDimensions={iconProps.selectorDimensions}
      paddingLeaveDimensions={iconProps.paddingLeaveDimensions}
      hoverRotationY={iconProps.hoverRotationY}
      cameraPositionSelected={iconProps.cameraPositionSelected}
      cameraTargetSelected={iconProps.cameraTargetSelected}
      calloutProps={calloutProps}
    >
      <group ref={blogNewsRef} dispose={null} scale={1}>
        <mesh
          geometry={nodes.WebExp_BlogNews.geometry}
          material={nodes.WebExp_BlogNews.material}
          rotation={[Math.PI / 2, 0, -Math.PI / 6]}
        />
      </group>
    </Icon>
  );
}

useGLTF.preload("/models/BlogNews-transformed.glb");
